import stylesheet from './Accordion.scss?inline';

import CustomComponent from "../../base/customComponent/CustomComponent";

class NXTAccordion extends CustomComponent {

    constructor() {
        super();
        this.customStyle = stylesheet;
    }

    render() {
        const tabBarContainer = document.createElement('div');
        tabBarContainer.classList.add('accordion');
        tabBarContainer.innerHTML = `
            <slot></slot>
        `;
        tabBarContainer.addEventListener('accordion-item-open', (ev) => {
            ev.stopPropagation();
            this.onOpenItem(ev)
        })
        return tabBarContainer;
    }

    onOpenItem(ev: Event) {
        this.querySelectorAll('nxt-accordion-item').forEach((item) => {
            if(ev.target !== item) {
                item.removeAttribute('selected');
            }
        })
    }

}

customElements.define('nxt-accordion', NXTAccordion);
